// extracted by mini-css-extract-plugin
export default {"jenga":"index_jenga__2O1fT","item":"index_item__1pHl1","top-left":"index_top-left__3G6DB","top-right":"index_top-right__2z-vw","bottom":"index_bottom__1u-tf"};